import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=2011b0cc&scoped=true"
import script from "./bar.vue?vue&type=script&lang=js"
export * from "./bar.vue?vue&type=script&lang=js"
import style0 from "./bar.vue?vue&type=style&index=0&id=2011b0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2011b0cc",
  null
  
)

export default component.exports